/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Filterprogressstatus_Inprogress5Inputs */

const nl_enums_filterprogressstatus_inprogress5 = /** @type {(inputs: Enums_Filterprogressstatus_Inprogress5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deels behandeld`)
};

/**

* @param {Enums_Filterprogressstatus_Inprogress5Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_filterprogressstatus_inprogress5 = /** @type {((inputs?: Enums_Filterprogressstatus_Inprogress5Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Filterprogressstatus_Inprogress5Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_filterprogressstatus_inprogress5(inputs)
});
export { enums_filterprogressstatus_inprogress5 as "enums.FilterProgressStatus.InProgress" }